module.exports = __webpack_public_path__ + "img/FR19870.61b8509e.png";